module.exports = __webpack_public_path__ + "static/media/laticinios_sao_vicente.5c1aacf8.jpeg";